import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AIExperienceContextPluginState } from './types';

export const aiExperienceContextPluginKey = new PluginKey<AIExperienceContextPluginState>(
	'aiExperienceContext',
);
